export const LOGOUT_TIME = 60 * 60 * 1000;
export const WARN_TIME = 2 * 60 * 1000; // minutes before logout (0 ms)
export const CHECK_RATE = 5 * 1000;
